// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"667":"194117a8","810":"fbfef39d","1901":"e7d17f77","3065":"99a6a7b8","4677":"fbfef39d","5380":"fbfef39d","8529":"1973eae6"}[chunkId] + ".chunk.css";
};